import { EventEmitter } from '@angular/core';
import * as i0 from "@angular/core";
export class EventYearService {
    constructor() {
        this.invokeFirstComponentFunction = new EventEmitter();
    }
    onYearChange(year) {
        this.invokeFirstComponentFunction.emit(year);
    }
}
EventYearService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function EventYearService_Factory() { return new EventYearService(); }, token: EventYearService, providedIn: "root" });
